import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppSetting } from '../models/app-setting.models';

@Injectable({
  providedIn: 'root',
})
export class AppSettingService {
  private http = inject(HttpClient);

  private apiUrl = `${environment.apiUrl}/api/appsettings`;

  /**
   * Get all application settings
   */
  getAllSettings(): Observable<AppSetting[]> {
    return this.http.get<AppSetting[]>(this.apiUrl);
  }

  /**
   * Get a specific setting by key
   */
  getSettingByKey(key: string): Observable<AppSetting> {
    return this.http.get<AppSetting>(`${this.apiUrl}/${encodeURIComponent(key)}`);
  }

  /**
   * Create or update a setting
   */
  upsertSetting(setting: AppSetting): Observable<AppSetting> {
    return this.http.post<AppSetting>(this.apiUrl, setting);
  }

  /**
   * Delete a setting (soft delete)
   */
  deleteSetting(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
